import React from "react";
import { Menu, MenuItem, Chip } from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const HomeCardActionsMenu = ({
  anchorEl,
  openMenu,
  handleClose,
  data,
  showSpacePopup,
  displayRemoveFromSpace,
  onRemoveFromSpaceClick,
  displayAddToSpace,
  onAddToSpaceClick,
  showRemove,
  onRemove,
  onDelete, // Add delete handler prop
  isFeedback,
  currentUser, // Add current user prop
}) => {
  // Check if the current user owns this rate
  // Try multiple ways to get user name (same pattern as HomeCardDialog)
  const currentUserName = currentUser?.user_name || currentUser?.username || currentUser?.name;
  const ratingUserName = data?.user_name || data?.username;
  const isOwner = currentUserName && ratingUserName && (currentUserName === ratingUserName);
  
  // Check if user is admin
  const userRole = currentUser?.role?.toLowerCase();
  const isAdmin = userRole === 'admin' || userRole === 'support';
  
  // Only show remove option if showRemove is true AND user owns the rate
  const shouldShowRemove = showRemove && isOwner;

  // Show delete only when remove is not already shown (avoids duplicate for owners in /my-reviews)
  // Admins who are not the owner still see it as "Remove"
  const shouldShowDelete = onDelete && (isAdmin || isOwner) && !shouldShowRemove;
  
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={openMenu}
      onClose={handleClose}
      onClick={(e) => {
        e.stopPropagation();
      }}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      slotProps={{
        backdrop: {
          onClick: (e) => {
            e.stopPropagation();
          }
        }
      }}
      sx={{
        zIndex: 9999,
        '& .MuiPaper-root': {
          zIndex: 9999,
          boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
          borderRadius: '12px',
          border: '1px solid rgba(226,232,240,0.3)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          backgroundColor: 'white',
          minWidth: '200px',
          opacity: 1,
          visibility: 'visible',
        }
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      {displayAddToSpace && (
        <MenuItem
          sx={{ paddingTop: "0", paddingBottom: "0" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
            onAddToSpaceClick();
          }}
        >
          <Chip
            className="viewCount"
            icon={<AddIcon className="menuIcon" />}
            sx={{ color: "rgba(38, 38, 38, 0.5) !important", pointerEvents: "none" }}
            label={"Add to space"}
          />
        </MenuItem>
      )}

      {!displayAddToSpace && (
        <MenuItem
          sx={{ paddingTop: "0", paddingBottom: "0" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
            showSpacePopup(data.object_id || data.id, data);
          }}
        >
          <Chip
            className="viewCount"
            icon={<QrCodeIcon className="menuIcon" />}
            sx={{ color: "rgba(38, 38, 38, 0.5) !important", pointerEvents: "none" }}
            label={"Add to collection"}
          />
        </MenuItem>
      )}

      {displayRemoveFromSpace && (
        <MenuItem
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
            onRemoveFromSpaceClick(data.id);
          }}
        >
          <Chip
            className="viewCount"
            icon={<DeleteIcon className="menuIcon" />}
            sx={{ color: "rgba(38, 38, 38, 0.5) !important", pointerEvents: "none" }}
            label={"Remove from current space"}
          />
        </MenuItem>
      )}

      {shouldShowRemove && (
        <MenuItem
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
            onRemove(data.id);
          }}
        >
          <Chip
            className="viewCount"
            icon={<DeleteIcon className="menuIcon" />}
            sx={{ color: "rgba(38, 38, 38, 0.5) !important", pointerEvents: "none" }}
            label={"Remove"}
          />
        </MenuItem>
      )}

      {shouldShowDelete && (
        <MenuItem
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
            const deleteId = data.rating_id || data.id;
            onDelete(deleteId);
          }}
        >
          <Chip
            className="viewCount"
            icon={<DeleteIcon className="menuIcon" />}
            sx={{ color: "rgba(220, 38, 38, 0.8) !important", pointerEvents: "none" }}
            label={"Remove"}
          />
        </MenuItem>
      )}
    </Menu>
  );
};

export default HomeCardActionsMenu;
